import React, { useState } from "react";
import Sidebar from "../../components/Sidebar/Sidebar";
import { HeaderStudents } from "../../components/Students/HeaderStudents/HeaderStudents";
import TableStudents from "../../components/Students/TableStudents/TableStudents";
import AddStudentModal from "../../components/Students/AddStudentModal/AddStudentModal";
import perfil from '../../assets/image/Home/perfil.png';
import "./Students.css";

/* --- Constantes de Dados --- */
const initialStudentData = [
    {
        id: "2023001",
        imgSrc: perfil,
        name: "Ana Silva",
        email: "ana.silva@email.com",
        telefone: "(11) 98765-4321",
        matricula: "2023001",
        curso: "Engenharia de Software",
        frequencia: "100%",
        desempenho: "10.0",
        disciplinas: [
            { id: 1, periodo: "2023.1", nome: "Programação Orientada a Objetos", nota: "10.0", freq: "100%" },
            { id: 2, periodo: "2023.1", nome: "Banco de Dados", nota: "2.8", freq: "18%" },
            { id: 3, periodo: "2023.1", nome: "Engenharia de Software I", nota: "9.2", freq: "95%" },
            { id: 4, periodo: "2023.1", nome: "Redes de Computadores", nota: "6.5", freq: "78%" },
            { id: 5, periodo: "2023.2", nome: "Programação Orientada a Objetos II", nota: "9.5", freq: "100%" },
            { id: 6, periodo: "2023.2", nome: "Banco de Dados Avançado", nota: "8.0", freq: "90%" },
            { id: 7, periodo: "2023.2", nome: "Engenharia de Software II", nota: "9.0", freq: "95%" },
            { id: 8, periodo: "2023.2", nome: "Redes de Computadores II", nota: "7.5", freq: "85%" },
            { id: 9, periodo: "2024.1", nome: "Inteligência Artificial", nota: "9.8", freq: "100%" },
            { id: 10, periodo: "2024.1", nome: "Desenvolvimento Web", nota: "9.0", freq: "95%" },
            { id: 11, periodo: "2024.1", nome: "Arquitetura de Software", nota: "8.5", freq: "90%" },
            { id: 12, periodo: "2024.1", nome: "Segurança da Informação", nota: "9.2", freq: "100%" },
            { id: 13, periodo: "2024.2", nome: "Machine Learning", nota: "9.7", freq: "100%" },
            { id: 14, periodo: "2024.2", nome: "Desenvolvimento Mobile", nota: "8.8", freq: "95%" },
            { id: 15, periodo: "2024.2", nome: "DevOps", nota: "9.0", freq: "100%" },
            { id: 16, periodo: "2024.2", nome: "Computação em Nuvem", nota: "9.5", freq: "100%" },
            { id: 17, periodo: "2025.1", nome: "Blockchain", nota: "9.3", freq: "100%" },
            { id: 18, periodo: "2025.1", nome: "Big Data", nota: "9.0", freq: "95%" },
            { id: 19, periodo: "2025.1", nome: "Internet das Coisas", nota: "9.2", freq: "100%" },
            { id: 20, periodo: "2025.1", nome: "Realidade Aumentada", nota: "9.4", freq: "100%" },
            { id: 21, periodo: "2025.2", nome: "Computação Quântica", nota: "9.6", freq: "100%" },
            { id: 22, periodo: "2025.2", nome: "Robótica Avançada", nota: "9.1", freq: "95%" },
            { id: 23, periodo: "2025.2", nome: "Sistemas Distribuídos", nota: "9.3", freq: "100%" },
            { id: 24, periodo: "2025.2", nome: "Análise de Dados", nota: "9.0", freq: "95%" },
        ],
        periodAttendanceSummary: [
            { id: 'p1_ana', period: "2023.1", frequency: "98%" },
            { id: 'p2_ana', period: "2023.2", frequency: "89%" },
            { id: 'p3_ana', period: "2024.1", frequency: "72%" },
            { id: 'p4_ana', period: "2024.2", frequency: "87%" },
            { id: 'p5_ana', period: "2025.1", frequency: "95%" },
            { id: 'p6_ana', period: "2025.2", frequency: "100%" },
        ],
        frequenciaDetalhada: [
            { id: 1, data: "10/05/2025", disciplinaNome: "Programação Orientada a Objetos", status: "Presente" },
            { id: 2, data: "09/05/2025", disciplinaNome: "Banco de Dados", status: "Presente" },
            { id: 3, data: "08/05/2025", disciplinaNome: "Engenharia de Software I", status: "Ausente" },
            { id: 4, data: "07/05/2025", disciplinaNome: "Redes de Computadores", status: "Presente" },
            { id: 5, data: "06/05/2025", disciplinaNome: "Programação Orientada a Objetos", status: "Presente" },
        ],
        anotacoesPrivadas: "A aluna tem demonstrado melhora significativa nas últimas semanas, especialmente em Programação Orientada a Objetos. Continua com dificuldades em Redes de Computadores."
    },
    {
        id: "2023002",
        imgSrc: perfil,
        name: "Carlos Oliveira",
        email: "carlos.oliveira@email.com",
        telefone: "(21) 91234-5678",
        matricula: "2023002",
        curso: "Ciência da Computação",
        frequencia: "78%",
        desempenho: "6.5",
        disciplinas: [
            { id: 1, periodo: "2023.1", nome: "Algoritmos Avançados", nota: "7.0", freq: "80%" },
            { id: 2, periodo: "2023.1", nome: "Inteligência Artificial", nota: "6.0", freq: "75%" },
            { id: 3, periodo: "2023.2", nome: "Compiladores", nota: "8.0", freq: "85%" },
        ],
        periodAttendanceSummary: [
            { id: 'p1_carlos', period: "2023.1", frequency: "77%" },
            { id: 'p2_carlos', period: "2023.2", frequency: "80%" },
        ],
        frequenciaDetalhada: [
            { id: 1, data: "10/05/2024", disciplinaNome: "Algoritmos Avançados", status: "Presente" },
            { id: 2, data: "09/05/2024", disciplinaNome: "Inteligência Artificial", status: "Ausente" },
            { id: 3, data: "08/05/2024", disciplinaNome: "Compiladores", status: "Presente" },
        ],
        anotacoesPrivadas: "O aluno apresenta dificuldades em Inteligência Artificial, mas tem bom desempenho em Algoritmos Avançados e Compiladores."
    },
    {
        id: "2023003",
        imgSrc: perfil,
        name: "Mariana Santos",
        email: "mariana.santos@email.com",
        telefone: "(31) 99988-7766",
        matricula: "2023003",
        curso: "Sistemas de Informação",
        frequencia: "95%",
        desempenho: "9.2",
        disciplinas: [
            { id: 1, periodo: "2023.1", nome: "Análise de Sistemas", nota: "9.0", freq: "96%" },
            { id: 2, periodo: "2023.2", nome: "Gestão de Projetos", nota: "9.5", freq: "94%" },
            { id: 3, periodo: "2023.2", nome: "Segurança da Informação", nota: "8.8", freq: "95%" },
        ],
        periodAttendanceSummary: [
            { id: 'p1_mariana', period: "2023.1", frequency: "96%" },
            { id: 'p2_mariana', period: "2023.2", frequency: "94%" },
        ],
        frequenciaDetalhada: [
            { id: 1, data: "10/05/2024", disciplinaNome: "Análise de Sistemas", status: "Presente" },
            { id: 2, data: "09/05/2024", disciplinaNome: "Gestão de Projetos", status: "Presente" },
            { id: 3, data: "08/05/2024", disciplinaNome: "Segurança da Informação", status: "Presente" },
        ],
        anotacoesPrivadas: "Mariana tem um bom desempenho em Análise de Sistemas e Gestão de Projetos, mas precisa melhorar em Segurança da Informação."
    },
    {
        id: "2023004",
        imgSrc: perfil,
        name: "Pedro Costa",
        email: "pedro.costa@email.com",
        telefone: "(41) 98877-6655",
        matricula: "2023004",
        curso: "Engenharia de Software",
        frequencia: "65%",
        desempenho: "2.8",
        disciplinas: [
            { id: 1, periodo: "2023.1", nome: "Qualidade de Software", nota: "5.0", freq: "70%" },
            { id: 2, periodo: "2023.1", nome: "Arquitetura de Software", nota: "6.0", freq: "60%" },
            { id: 3, periodo: "2023.2", nome: "Testes de Software", nota: "5.5", freq: "65%" },
        ],
        periodAttendanceSummary: [
            { id: 'p1_pedro', period: "2023.1", frequency: "68%" },
            { id: 'p2_pedro', period: "2023.2", frequency: "62%" },
        ],
        frequenciaDetalhada: [
            { id: 1, data: "10/05/2024", disciplinaNome: "Qualidade de Software", status: "Ausente" },
            { id: 2, data: "09/05/2024", disciplinaNome: "Arquitetura de Software", status: "Ausente" },
            { id: 3, data: "08/05/2024", disciplinaNome: "Testes de Software", status: "Presente" },
            { id: 4, data: "07/05/2024", disciplinaNome: "Qualidade de Software", status: "Ausente" },
        ],
        anotacoesPrivadas: "Pedro está enfrentando dificuldades em Qualidade de Software e Arquitetura de Software, mas mostra progresso em Testes de Software."
    },
    {
        id: "2023005",
        imgSrc: perfil,
        name: "Juliana Lima",
        email: "juliana.lima@email.com",
        telefone: "(51) 97766-5544",
        matricula: "2023005",
        curso: "Ciência da Computação",
        frequencia: "88%",
        desempenho: "7.9",
        disciplinas: [
            { id: 1, periodo: "2023.1", nome: "Estrutura de Dados", nota: "8.2", freq: "90%" },
            { id: 2, periodo: "2023.2", nome: "Sistemas Operacionais", nota: "7.5", freq: "85%" },
            { id: 3, periodo: "2023.2", nome: "Teoria da Computação", nota: "7.9", freq: "89%" },
        ],
        periodAttendanceSummary: [
            { id: 'p1_juliana', period: "2023.1", frequency: "90%" },
            { id: 'p2_juliana', period: "2023.2", frequency: "87%" },
        ],
        frequenciaDetalhada: [
            { id: 1, data: "10/05/2024", disciplinaNome: "Estrutura de Dados", status: "Presente" },
            { id: 2, data: "09/05/2024", disciplinaNome: "Sistemas Operacionais", status: "Presente" },
            { id: 3, data: "08/05/2024", disciplinaNome: "Teoria da Computação", status: "Presente" },
        ],
        anotacoesPrivadas: "Juliana está progredindo em Estrutura de Dados e Teoria da Computação, mas precisa melhorar em Sistemas Operacionais."
    },
    {
        id: "2023006",
        imgSrc: perfil,
        name: "Rafael Mendes",
        email: "rafael.mendes@email.com",
        telefone: "(61) 96655-4433",
        matricula: "2023006",
        curso: "Sistemas de Informação",
        frequencia: "82%",
        desempenho: "7.2",
        disciplinas: [
            { id: 1, periodo: "2023.1", nome: "Modelagem de Processos", nota: "7.0", freq: "80%" },
            { id: 2, periodo: "2023.2", nome: "Business Intelligence", nota: "7.5", freq: "85%" },
            { id: 3, periodo: "2023.2", nome: "Governança de TI", nota: "6.8", freq: "81%" },
        ],
        periodAttendanceSummary: [
            { id: 'p1_rafael', period: "2023.1", frequency: "80%" },
            { id: 'p2_rafael', period: "2023.2", frequency: "83%" },
        ],
        frequenciaDetalhada: [
            { id: 1, data: "10/05/2024", disciplinaNome: "Modelagem de Processos", status: "Presente" },
            { id: 2, data: "09/05/2024", disciplinaNome: "Business Intelligence", status: "Presente" },
            { id: 3, data: "08/05/2024", disciplinaNome: "Governança de TI", status: "Ausente" },
        ],
        anotacoesPrivadas: "Rafael está progredindo em Modelagem de Processos e Business Intelligence, mas precisa melhorar em Governança de TI."
    },
    {
        id: "2023007",
        imgSrc: perfil,
        name: "Fernanda Alves",
        email: "fernanda.alves@email.com",
        telefone: "(71) 95544-3322",
        matricula: "2023007",
        curso: "Engenharia de Software",
        frequencia: "75%",
        desempenho: "6.8",
        disciplinas: [
            { id: 1, periodo: "2023.1", nome: "Programação Web", nota: "7.2", freq: "78%" },
            { id: 2, periodo: "2023.2", nome: "Desenvolvimento Mobile", nota: "6.5", freq: "70%" },
            { id: 3, periodo: "2023.2", nome: "DevOps", nota: "6.9", freq: "77%" },
        ],
        periodAttendanceSummary: [
            { id: 'p1_fernanda', period: "2023.1", frequency: "78%" },
            { id: 'p2_fernanda', period: "2023.2", frequency: "72%" },
        ],
        frequenciaDetalhada: [
            { id: 1, data: "10/05/2024", disciplinaNome: "Programação Web", status: "Presente" },
            { id: 2, data: "09/05/2024", disciplinaNome: "Desenvolvimento Mobile", status: "Ausente" },
            { id: 3, data: "08/05/2024", disciplinaNome: "DevOps", status: "Presente" },
        ],
        anotacoesPrivadas: "Fernanda está progredindo em Programação Web e DevOps, mas precisa melhorar em Desenvolvimento Mobile."
    },
    {
        id: "2023008",
        imgSrc: perfil,
        name: "Lucas Pereira",
        email: "lucas.pereira@email.com",
        telefone: "(81) 94433-2211",
        matricula: "2023008",
        curso: "Ciência da Computação",
        frequencia: "90%",
        desempenho: "8.5",
        disciplinas: [
            { id: 1, periodo: "2023.1", nome: "Redes Neurais", nota: "8.8", freq: "100%" },
            { id: 2, periodo: "2023.1", nome: "Processamento de Imagens", nota: "8.0", freq: "88%" },
            { id: 3, periodo: "2023.2", nome: "Computação Gráfica", nota: "8.5", freq: "90%" },
        ],
        periodAttendanceSummary: [
            { id: 'p1_lucas', period: "2023.1", frequency: "94%" },
            { id: 'p2_lucas', period: "2023.2", frequency: "88%" },
        ],
        frequenciaDetalhada: [
            { id: 1, data: "10/05/2024", disciplinaNome: "Redes Neurais", status: "Presente" },
            { id: 2, data: "09/05/2024", disciplinaNome: "Processamento de Imagens", status: "Presente" },
            { id: 3, data: "08/05/2024", disciplinaNome: "Computação Gráfica", status: "Presente" },
        ],
        anotacoesPrivadas: "Lucas está progredindo em Redes Neurais e Processamento de Imagens, mas precisa melhorar em Computação Gráfica."
    }
];

const cursoOptionsForAddModal = ["Engenharia de Software", "Ciência da Computação", "Sistemas de Informação"];

/* --- Componente de Página --- */
function StudentsPage() {
    /* --- Estados --- */
    const [students, setStudents] = useState(initialStudentData);
    const [isAddStudentModalOpen, setIsAddStudentModalOpen] = useState(false);

    /* --- Manipuladores (Handlers) --- */
    const openAddStudentModal = () => setIsAddStudentModalOpen(true);
    const closeAddStudentModal = () => setIsAddStudentModalOpen(false);

    const handleAddStudent = (newStudentFromForm) => {
        const studentWithDefaults = {
            id: newStudentFromForm.matricula || `new-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`,
            imgSrc: perfil,
            frequencia: "N/A",
            desempenho: "N/A",
            disciplinas: [], 
            periodAttendanceSummary: [], 
            frequenciaDetalhada: [],
            anotacoesPrivadas: "",
            ...newStudentFromForm,
        };
        setStudents(prevStudents => [...prevStudents, studentWithDefaults]);
    };

    /* --- Renderização --- */
    return (
        <div className="app-container-students">
            <Sidebar />
            <main className="main-content-students">
                <HeaderStudents onOpenAddStudentModal={openAddStudentModal} />
                <TableStudents initialStudents={students} />
            </main>
            <AddStudentModal
                isOpen={isAddStudentModalOpen}
                onClose={closeAddStudentModal}
                onAddStudent={handleAddStudent}
                cursoOptions={cursoOptionsForAddModal}
            />
        </div>
    );
}

export default StudentsPage;